module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/mobile@2x_503bbc.jpg";